import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';
import { DatePipe } from '@angular/common';
import { AlertService } from '../../../services/alert.service';

@Component({
  selector: 'app-letter-accc',
  templateUrl: './letter-accc.component.html',
  styleUrls: ['./letter-accc.component.scss'],
  providers: [DatePipe]
})
export class LetterACCComponent implements OnInit {
  
  @Input() signature_url: string;
  @Input() current_first_transaction_date: string;
  @Input() mount: string='';
  @Input() bank: string='';
  @Input() total: string='';
  @Input() iva: string='';
  @Input() account_number: string='';
  @Input() comission: string='';
  @Input() percent: string='';
  reserve:any
  employee: any;
  date:any
  dateText:any
constructor(public modalController : ModalController,private authService:AuthService,private alertService:AlertService) { 
    this.date = this.alertService.getCurrentDate()
    this.dateText=this.alertService.dateFormatText()
  }

  ngOnInit() {
    this.authService.user().subscribe(
      (data:any)=>{
        this.employee = data.high_employee;
        this.employee.name=data.high_employee.name+" "+data.high_employee.paternal_last_name+" "+data.high_employee.mother_last_name
      }
    );
  }

  closeModal(){
    this.modalController.dismiss();
  }
numberTransform(number) {
    number = Number(String(number).replace(/,/g, '')) || 0;
    if (number === 0) {
        return ' (Cero Pesos 00/100 M.N.)';
    }
    if (number === 1) {
        return ' (Un Peso 00/100 M.N.)';
    }
    if (number > 0 && number < 1) {
        let centavos = String(number).split('.')[1] || '0';
        if (centavos.length === 1) {
            return ` (Cero Pesos ${centavos}0/100 M.N.)`;
        }
        return ` (Cero Pesos ${centavos}/100 M.N.)`;
    }
    if (number > 1 && number < 2) {
        let centavos = String(number).split('.')[1] || '0';
        if (centavos.length === 1) {
            return ` (Un Peso ${centavos}0/100 M.N.)`;
        }
        return ` (Un Peso ${centavos}/100 M.N.)`;
    }

    let centavos;
    if (String(number).includes('.')) {
        let partes = String(number).split('.');
        if (partes[1].length === 1) {
            centavos = partes[1] + '0/100 M.N.)';
        } else {
            centavos = partes[1] + '/100 M.N.)';
        }
    } else {
        centavos = '00/100 M.N.)';
    }

    let numeroFinal = this.numToText(Math.floor(number));
    return ` (${numeroFinal} Pesos ${centavos}`;
}

 numToText(number) {
    const words = {
        0: '', 1: 'Un', 2: 'Dos', 3: 'Tres', 4: 'Cuatro', 5: 'Cinco',
        6: 'Seis', 7: 'Siete', 8: 'Ocho', 9: 'Nueve', 10: 'Diez',
        11: 'Once', 12: 'Doce', 13: 'Trece', 14: 'Catorce', 15: 'Quince',
        16: 'Dieciseis', 17: 'Diecisiete', 18: 'Dieciocho', 19: 'Diecinueve',
        20: 'Veinte', 30: 'Treinta', 40: 'Cuarenta', 50: 'Cincuenta',
        60: 'Sesenta', 70: 'Setenta', 80: 'Ochenta', 90: 'Noventa',
        100: 'Cien', 200: 'Doscientos', 300: 'Trescientos', 400: 'Cuatrocientos',
        500: 'Quinientos', 600: 'Seiscientos', 700: 'Setecientos',
        800: 'Ochocientos', 900: 'Novecientos'
    };

    if (number <= 20) {
        return words[number];
    } else if (number >= 20 && number < 30) {
        return 'Veinti' + (words[String(number)[1]] === 'Tres' ? 'trés' : words[String(number)[1]].toLowerCase());
    }
    if (number <= 100 || [200, 300, 400, 500, 600, 700, 800, 900].includes(number)) {
        let text = words[10 * Math.floor(number / 10)];
        if (number % 10 !== 0) {
            text += ' y ' + words[number % 10];
        }
        return text;
    } else if (number > 100 && number < 200) {
        return 'Ciento ' + this.numToText(number % 100);
    } else if ((number > 200 && number < 500) || (number > 600 && number < 700) || (number > 800 && number < 900)) {
        return this.numToText(parseInt(String(number)[0])) + 'cientos ' + this.numToText(number % 100);
    } else if (number > 500 && number < 600) {
        return 'Quinientos ' + this.numToText(number % 100);
    } else if (number > 700 && number < 800) {
        return 'Setecientos ' + this.numToText(number % 100);
    } else if (number > 900 && number < 1000) {
        return 'Novecientos ' + this.numToText(number % 100);
    }

    if (number < 1000000) {
        let unit = Math.floor(number / 1000);
        if (unit === 1) {
            return 'Mil ' + this.numToText(number % 1000);
        }
        return this.numToText(unit) + ' Mil ' + this.numToText(number % 1000);
    }

    let unit = Math.floor(number / 1000000);
    if (unit === 1) {
        return 'Un Millón ' + this.numToText(number % 1000000);
    }
    return this.numToText(unit) + ' Millones ' + this.numToText(number % 1000000);
}
}
